import React, { useState } from "react";
import ScraperModuleFormField from "./ScraperModuleFormField";



const UpdateScraperModule = () => {

    const [crumbs] = useState([
        { content: "Home", url: "/home" },
        { content: "Scraper Modules", url: "/scrapers-modules" },
        { content: "Update Scraper Module", url: "" }
    ]
    )



    return (
        <>
            <ScraperModuleFormField crumbs={crumbs} title={"Update Scraper Module"} btnText={"Update"} />

        </>
    )

}
export default UpdateScraperModule;